import { linkifyText } from "@/lib/bibleLinkify";

export default function VerseText({ text, className = "", testId }) {
  if (!text) return null;
  return (
    <span
      data-testid={testId}
      className={className}
      dangerouslySetInnerHTML={{ __html: linkifyText(text) }}
    />
  );
}
